import {axiosAPI} from "./axiosClient"
import qs from "qs"
import { getParams } from '../helper/Helper'


export const ContributionService = {

  getContributions(folderId, params) {
    return axiosAPI.get(`/${folderId}/contributions?${getParams(params)}`)
  },

  updateContribution(folderId, dataPost){
    return axiosAPI.put(`/${folderId}/contributions`, qs.stringify(dataPost))
  },
  
  postContribution(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/contributions`, qs.stringify(dataPost))
  },

  postContributionPlanification(folderId, contributionId, dataPost){
    return axiosAPI.post(`/${folderId}/contributions/${contributionId}/planification`, qs.stringify(dataPost)) ///contributions/{{contrib_tgc_id_1}}/planification
  },
  
  removePlanContribution(folderId, contributionId, params) {
    return axiosAPI.delete(`/${folderId}/contributions/${contributionId}/planification?${getParams(params)}`)
  },

  removeContribution(folderId, contributionId) {
    return axiosAPI.delete(`/${folderId}/contributions/${contributionId}`)
  },

}